// Main javascript entry point
// Should handle bootstrapping/starting application

'use strict';

window.$ = jQuery;

var Emergencycontacttakeover = require('../_modules/emergencycontacttakeover/emergencycontacttakeover');
var PromotionalBar = require('../_modules/promotional-bar/promotional-bar');
var FurtherHelp = require('../_modules/further-help/further-help');
var PublicHealthAlerts = require('../_modules/public-health-alerts/public-health-alerts');
var News = require('../_modules/news/news');
var FeatureBanner = require('../_modules/feature-banner/feature-banner');
var MegaMenu = require('../_modules/mega-menu/mega-menu');
var Accordion = require('../_modules/accordion/accordion');
var CampaignBanner = require('../_modules/campaign/campaign-banner/campaign-banner');
var CampaignPromoted = require('../_modules/campaign/campaign-promoted/campaign-promoted');
var CampaignRelated = require('../_modules/campaign/campaign-related/campaign-related');
var SectionLandingBanner = require('../_modules/section-landing/section-landing-banner/section-landing-banner');
var SectionLandingFurtherHelp = require('../_modules/section-landing/section-landing-further-help/section-landing-further-help');
var SectionLandingSubnavigation = require('../_modules/section-landing/section-landing-subnavigation/section-landing-subnavigation');
var DatePicker = require('../_modules/date-picker/date-picker');
var BackToTop = require('../_modules/back-to-top/back-to-top');
var SearchListing = require('../_modules/search/search-listing/search-listing');
var SearchTerms = require('../_modules/search/search-terms/search-terms');
var SearchFacet = require('../_modules/search/search-facets/search-facets')
var SideNavigation = require('../_modules/side-navigation/side-navigation');
var PushNotification = require('../_modules/push-notification/push-notification');
var DepartmentWaitingTime = require('../_modules/department-waiting-time/department-waiting-time');
var SearchInPageSearch = require('../_modules/search/search-in-page-search/search-in-page-search');
var Services = require('../_modules/taxonomy/services/services');


$(function() {
  new Emergencycontacttakeover();
  new PromotionalBar();
  new FurtherHelp();
  new PublicHealthAlerts();
  new News();
  new FeatureBanner();
  new MegaMenu();
  new Accordion();
  new CampaignBanner();
  new CampaignPromoted();
  new CampaignRelated();
  new SectionLandingBanner();
  new SectionLandingFurtherHelp();
  new SectionLandingSubnavigation();
  new DatePicker();
  new BackToTop();
  new SearchListing();
  new SearchTerms();
  new SearchFacet();
  new SideNavigation();
//  new PushNotification();
  new DepartmentWaitingTime();
  new SearchInPageSearch();
  new Services();

  //universal target all external links to open in a new tab
  $("a[href^='http://']").attr("target","_blank");
  $("a[href^='https://']").attr("target","_blank");
});
